const { randomUUID } = require('@/utils');

/**
 * 获取唯一键配置
 * @typedef {Object} UniqueOptions
 * @property {number} row_index 行索引
 * @property {number} column_index 列索引
 * @property {string} property 列属性名
 * @property {string} custom_key 自定义键名
 */

/**
 * 获取唯一键
 * @param {UniqueOptions} config 配置
 * @returns {string}
 */
const getUniqueKey = ({ row_index, column_index, property, custom_key }) => {
  const keys = [row_index, column_index, property, custom_key];
  return keys.join('_');
};

/**
 * 获取Popover组件的ref名
 * @param {UniqueOptions} config 配置
 * @returns {string}
 */
const getPopoverRefKey = (config) => {
  return getUniqueKey({
    ...config,
    custom_key: `${randomUUID()}_table_el_popover_ref`,
  });
};

/**
 * 关闭Popover
 * @param {Object} s 组件实例对象
 * @param {string} key ref键名
 * @returns {void}
 */
const closePopover = (s, key) => {
  s.$refs[key].doClose?.();
};

/**
 * 显示Popover
 * @param {Object} s 组件实例对象
 * @param {string} key ref键名
 * @returns {void}
 */
const showPopover = (s, key) => {
  s.$refs[key].doShow?.();
};

module.exports = (s) => {
  return [
    {
      name: '模板ID',
      value: 'id',
    },
    {
      name: '模板名称',
      value: 'name',
      format: (row, column, _, row_index) => {
        const h = s.$createElement;
        const { id, name } = row;
        const { property } = column;
        const base_popover_options = {
          row_index,
          column_index: column.index,
          property,
        };
        const popover_ref_key = getPopoverRefKey(base_popover_options);
        const ele = h(
          'div',
          {
            class: 'flex items-center',
          },
          [
            h(
              'div',
              {
                class: 'ml-10 mr-10 min-w-0 truncate',
              },
              name,
            ),
            h(
              'el-popover',
              {
                ref: popover_ref_key,
                props: {
                  trigger: 'manual',
                },
              },
              [
                h(
                  'i',
                  {
                    slot: 'reference',
                    class: 'el-icon-edit-outline font-16 cursor-pointer',
                    on: {
                      click() {
                        s.closeAllTablePopover();
                        s.form_data_config.name.name.value = name;
                        showPopover(s, popover_ref_key);
                      },
                    },
                  },
                  null
                ),
                h(
                  'app-form',
                  {
                    props: {
                      formData: s.form_data_config.name,
                    },
                    on: {
                      cancel() {
                        closePopover(s, popover_ref_key);
                      },
                      async confirm(params) {
                        if (!params.name) {
                          s.$message.warning('请输入模板名称');
                          return;
                        }
                        await s?.onEdit(params, id);
                        closePopover(s, popover_ref_key);
                      },
                    },
                  },
                  null
                ),
              ]
            ),
          ]
        );
        return ele;
      },
    },
    {
      name: '已生成内容数',
      value: 'create_advertiser_source_success_num',
    },
    {
      name: '创建时间',
      value: 'created_at',
    },
    {
      name: '操作',
      width: 300,
      format: (row) => {
        const { id } = row;
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-link',
              {
                class: 'mr-10',
                props: {
                  underline: false,
                  type: 'primary',
                },
                on: {
                  click: () => {
                    s.onView(id);
                  },
                },
              },
              '查看模板'
            ),
            h('el-link',
              {
                class: 'mr-10',
                props: {
                  underline: false,
                  type: 'success',
                },
                on: {
                  click: () => {
                    s.onCreateSource(row);
                  },
                },
              },
              '创建内容'
            ),
            h('el-link',
              {
                class: 'mr-10',
                props: {
                  underline: false,
                  type: 'info',
                },
                on: {
                  click: () => {
                    s.onDel(row);
                  },
                },
              },
              '删除模板'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
